/* @flow */
// typecheck: ignore file
import qs from 'qs';
import React from 'react';

import CurrentUser from 'auth/CurrentUser';
import Group from 'entities/Group';
import GroupCreateModal from 'groups/components/GroupCreateModal.jsx';
import GroupInviteModal from 'groups/components/GroupInviteModal.jsx';
import GroupSettingsModal from 'groups/components/GroupSettingsModal.jsx';
import GroupStore from 'groups/stores/GroupStore';
import GroupSubscribedSettingModal from 'groups/components/GroupSubscribedSettingModal.jsx';
import JoinConfirmSubscriptionModal from 'join/components/JoinConfirmSubscriptionModal.jsx';
import Message from 'entities/Message';
import MessageActions from 'groups/actions/MessageActions';
import getRedirectLocationAfterGroupCreation from 'utils/getRedirectLocationAfterGroupCreation';

import type { Location } from 'lib/ReactRouterTypes';

function handleGroupCreated(router: Object) {
  return (group) => {
    router.push(getRedirectLocationAfterGroupCreation(group));
  };
}

/* eslint-disable consistent-return */
export default function getModalToDisplayForQuery(router: Object, group: ?Group, location: Location): ?React$Element<*> {
  const queryData = qs.parse(location.query);
  const queryActionData = queryData.actionData;

  if ('join' in queryData) {
    const joinCode = queryData.join;
    const groupToJoin = GroupStore.getGroupForCode(joinCode);
    if (groupToJoin) {
      // already joined
      return null;
    } else {
      return <JoinConfirmSubscriptionModal code={joinCode} />;
    }
  }

  if ('action' in queryData) {
    if (queryActionData) {
      MessageActions.saveAndShowDraftFromQuery(queryActionData);
      router.replace(location.pathname); // messy side effects
      return null;
    } else if (queryData.action === 'new-message') {
      MessageActions.saveAndShowDraftAnnouncement(new Message());
      router.replace(location.pathname);
      return null;
    } else if (queryData.action === 'new-class') {
      return <GroupCreateModal onCreate={handleGroupCreated(router)} />;
    }
  }

  if (!group) {
    return null;
  }

  if ('settings' in queryData) {
    if (group.canEdit()) {
      return (
        <GroupSettingsModal
          group={group}
          onCodeChange={groupCode => router.push(`/classes/${groupCode}`)}
          userIsTeacher={CurrentUser.getUser().isTeacher()}
        />
      );
    } else {
      return <GroupSubscribedSettingModal group={group} />;
    }
  }

  // Show GroupInviteModal for the class created during setup
  if (GroupStore.getGroupCreatedDuringSetup() === group) {
    GroupStore.clearGroupCreatedDuringSetup();
    return <GroupInviteModal group={group} />;
  }

  if ('invite' in queryData) {
    // $FlowIssue can't see initialTab?
    return <GroupInviteModal group={group} initialTab={GroupInviteModal.TABS.INVITE} />;
  }
}



// WEBPACK FOOTER //
// ./src/lib/getModalToDisplayForQuery.js